import { render } from "./ConfirmOrderCard.vue?vue&type=template&id=ad803a78&scoped=true"
import script from "./ConfirmOrderCard.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderCard.vue?vue&type=script&lang=js"

import "./ConfirmOrderCard.vue?vue&type=style&index=0&id=ad803a78&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad803a78"]])

export default __exports__